goog.provide('el8.appshared.signOff');

goog.require('el8.model.identify');
goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.base');
goog.require('el8.appshared.message');

el8.appshared.signOff = function( item, callbackFn ) {
 
    if (el8.model.identify.isReport(item)) {
        el8.appservice.notifier.notify(item.getNotifyText('SAVE_IN_PROGRESS'));
        item.saveSignOff( function() {
            var feed = el8.appchart.reportFeeds.feeds[item.getReportType()];
            if (feed) {
                feed.signOffCallbackFn(item);
            }
            el8.appservice.notifier.notify(item.getNotifyText('MOVED_TO_FEED'));
            if (callbackFn) { callbackFn(); }
        });

    } else if ( el8.model.identify.isThread( item ) ) {
        var divButtonsId = 'threadButtons_' + item.getId();
        $('#' + divButtonsId).hide();
        item.signOff(function(newThread, data) {
            if (callbackFn) { callbackFn(); }
        });
    }

    return null;
};
